<ng-container *ngIf="is_loading">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</ng-container>


<div style="margin-top: 30px">
  <form [formGroup]="myForm" (ngSubmit)="onSubmit()"  novalidate>

    <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="20px">

      <div>
        <mat-card style="width: 300px; height: 100%">
          <mat-toolbar color="primary" class="mat-elevation-z16">
            <mat-toolbar-row>
              <span>Reset Password</span>
            </mat-toolbar-row>
          </mat-toolbar>


          <mat-card-content fxLayout="column">
            <mat-form-field style="margin-top: 15px">
              <mat-label>Email:</mat-label>
              <input matInput type="email" placeholder="me@user.com"  (focus)="onFocus()" formControlName="email" autocomplete="email">
              <mat-error>
                <strong>Valid email address required</strong>
              </mat-error>
            </mat-form-field>
          </mat-card-content>
          <div *ngIf="is_form_error">
            <mat-error style="margin-bottom: 5px">
              <strong>{{form_error_message}}</strong>
            </mat-error>
          </div>



          <button mat-raised-button color="accent" [disabled]="!myForm.valid" type="submit">Reset Password</button>
          <a style="margin-left: 10px" routerLinkActive="active" [routerLink]="['/login']">Login</a>

<!--          <mat-progress-bar *ngIf="is_loading" mode="indeterminate" style="margin-top: 10px"></mat-progress-bar>-->
        </mat-card>
      </div>
    </div>

  </form>
</div>
